import { Box, Stack, StackProps, Tooltip, Typography, TypographyProps } from '@mui/material';  
import { ReactComponent as ReloadIcon } from '../../assets/reload.svg';  
import ChevronRightIcon from '@mui/icons-material/ChevronRight';  
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';  
import { Link } from 'react-router-dom';  
import { ReactComponent as ContactIcon } from '../../assets/contact-icon.svg';  
import PhoneIcon from "@mui/icons-material/Phone";  
import { SxProps, useTheme } from "@mui/material/styles";  
import HighlightedText from 'components/GlobalSearch/HighlightText';  
  
type TitleObject = {  
	text: string;  
	link?: string; // Optional link if the title is clickable  
	state?: any;   
	onClick?: (e?: any) => void;  
};  
  
type contactObject = {  
	name: string;  
	email: string;  
	phone: number  
};  
  
type PageHeaderProps = {  
	title?: string | Array<string> | Array<TitleObject>;  
	icon?: string;  
	iconSize?: number;  
	lastSync?: string | null;  
	lastSyncPBI?: string | null;  
	children?: React.ReactNode;  
	childrenContainerProps?: StackProps;  
	isDataRefresh?: boolean;  
	hideTitle?: boolean;  
	hideIcon?: boolean;  
	executiveData?: boolean;  
	executiveContact?: contactObject;  
	exeLastSync?: string;  
	iconPadding?: string;  
	alertContent?: string | null;  
	hasEllipsis?: boolean;  
	stickyTop?: number;  
	headerSx?: SxProps;  
	isPepwise2Breadcrumb?: boolean;  
};  
  
const breadCrumbStyle: TypographyProps = {  
	textOverflow: 'ellipsis',  
	overflow: 'hidden',  
	whiteSpace: 'nowrap',  
	maxWidth: '125px'  
};  

const PEPWISE2_BREADCRUMB_COLOR = '#737A9E';
const PEPWISE2_CURRENT_BREADCRUMB_COLOR = '#000000';

const getBreadcrumbColor = (
	isPepwise2Breadcrumb: boolean,
	isCurrentPage: boolean
) => {
	if (!isPepwise2Breadcrumb) {
		return 'textLight.dark';
	}

	if (isCurrentPage) {
		return PEPWISE2_CURRENT_BREADCRUMB_COLOR;
	}

	return PEPWISE2_BREADCRUMB_COLOR;
};

const getBreadcrumbFontWeight = (
	isPepwise2Breadcrumb: boolean,
	isCurrentPage: boolean
) => {
	if (!isPepwise2Breadcrumb) {
		return undefined;
	}

	if (isCurrentPage) {
		return 500;
	}

	return 400;
};

const formatBreadcrumbText = (text: string, isPepwise2Breadcrumb: boolean) => {
	if (!isPepwise2Breadcrumb) {
		return text;
	}

	return text.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};
  
const PageHeader = ({  
	title,  
	icon,  
	iconSize,  
	lastSync,  
	lastSyncPBI,  
	children,  
	childrenContainerProps,  
	isDataRefresh = false,  
	hideTitle = false,  
	hideIcon = false,  
	executiveData = false,  
	executiveContact,  
	exeLastSync,  
	iconPadding,  
	alertContent,  
	hasEllipsis = true,  
	stickyTop = 76,  
	headerSx,  
	isPepwise2Breadcrumb = false  
}: PageHeaderProps) => {  
	const theme= useTheme();  
	const colors = theme.palette;  

	const resolvedStickyTop = isPepwise2Breadcrumb
		? { xs: stickyTop + 16, sm: stickyTop + 16, md: stickyTop + 16, lg: stickyTop }
		: stickyTop;
  
	const handleClick = (event: any, title: string, link?: any) => {  
		if (event.type === 'click' && title === 'Incident Details' && link === '/dataestate/majorIncident') {  
			localStorage.setItem('deMajorIncident', 'true');  
		}  
	};  

	const renderBreadcrumbSeparator = (isLastItem: boolean, isObjectItem = false) => {
		if (isLastItem) {
			return null;
		}

		if (isPepwise2Breadcrumb) {
			return (
				<Typography  
					variant="pageHeader"  
					sx={{  
						color: PEPWISE2_BREADCRUMB_COLOR,  
						mx: 0.75,  
						fontWeight: 400,
						fontSize: '18px !important',
						textTransform: 'none !important'
					}}  
				>  
					/  
				</Typography>
			);
		}

		if (isObjectItem) {
			return <ChevronRightIcon sx={{color: 'textLight.dark'}} />;
		}

		return <ChevronRightIcon />;
	};
  
	return (  
		<Stack  
			direction={{ xs: 'column', md: 'row' }}  
			justifyContent={{ xs: 'center', md: 'space-between' }}  
			position="sticky"  
			top={resolvedStickyTop}  
			zIndex={100}  
			bgcolor={colors.backgroundLight.primary}  
			px={isPepwise2Breadcrumb ? 0 : {xs: 0, sm: 2}}  
			sx={{ minHeight: '50px', ...headerSx }}  
		>  
			<Stack direction="row" gap={0.5} alignItems="center">  
  
				{!hideTitle && !!title && (  
					typeof title === 'string' ? (  
						<>  
							<Typography variant="pageHeader" color={colors.textLight.dark}>{<HighlightedText text={title} />}</Typography>  
						{executiveContact?.name && <Tooltip title={  
							<><Typography variant="bodyText" color="light.diff" style={{ color: 'rgba(169, 173, 203, 1)', fontStyle: 'italic'}}>Contact Person</Typography>  
							<Typography variant="bodyText" color="inherit">{executiveContact.name} </Typography>  
							<Typography variant="bodyText" color="light.diff" style={{ color: 'rgba(245, 245, 245, 1)', fontStyle: 'italic'}}>{executiveContact.email}</Typography>  
							{ !executiveContact.phone && <Typography variant="bodyText" color="light.diff" style={{ color: 'rgba(245, 245, 245, 1)', fontStyle: 'italic'}}><PhoneIcon style={{ verticalAlign: "middle", width: '15px', height: '15px', color: 'blue' }} /> {executiveContact.phone}</Typography> }  
							</>  
							} arrow>  
							<ContactIcon style={{ verticalAlign: 'middle', marginLeft: '5px' }} />  
						</Tooltip>}  
						{ executiveData && <Box>  
							<Stack direction="row" color="light.main" style={{ color: 'rgba(113, 117, 143, 1)'}} gap={0.5} ml={1}>  
							<ReloadIcon /> <Typography variant="bodyText" component="span"> Last Refreshed: {exeLastSync} </Typography>  
							</Stack>					  
						</Box> }  
						</>  
					) : (  
						<Stack direction="row" alignItems="center" flexWrap="wrap">  
							{isPepwise2Breadcrumb && (  
								<ChevronLeftIcon  
									sx={{  
										color: PEPWISE2_BREADCRUMB_COLOR,  
										fontSize: '30px',  
										mr: 0.5  
									}}  
								/>  
							)}  
							{title.map((item, idx) => {
								const isCurrentPage = idx === title.length - 1;
								const breadcrumbColor = getBreadcrumbColor(
									isPepwise2Breadcrumb,
									isCurrentPage
								);
								const breadcrumbFontWeight = getBreadcrumbFontWeight(
									isPepwise2Breadcrumb,
									isCurrentPage
								);

								if (typeof item === 'string') {
									return (  
										<Stack key={`${item}-${idx}`} direction="row" alignItems="center">  
											<Typography  
												variant="pageHeader"  
												sx={{  
													color: breadcrumbColor,
													fontWeight: breadcrumbFontWeight,
													...(isPepwise2Breadcrumb && {
														fontSize: '18px !important',
														textTransform: 'none !important'
													})
												}}  
												{...((idx < title.length - 1 || item.length > 60) && idx !== 2 && breadCrumbStyle)}  
											>  
												{formatBreadcrumbText(item, isPepwise2Breadcrumb)}  
											</Typography>  
											{renderBreadcrumbSeparator(isCurrentPage)}
										</Stack>  
									);
								}

								return (  
									<Stack key={`${item.text}-${idx}`} direction="row" alignItems="center">  
										{item.link ? (  
											<Box  
												component={Link}  
												to={item.link}  
												state={item.state}  
												sx={{  
													color: breadcrumbColor,  
													textDecoration: 'none',  
													...((idx < title.length - 1 || item.text.length > 60) && breadCrumbStyle)  
												}}  
											>  
												<Typography  
													variant="pageHeader"  
													title={item.text}  
													sx={{  
														color: breadcrumbColor,
														fontWeight: breadcrumbFontWeight,
														...(isPepwise2Breadcrumb && {
															fontSize: '18px !important',
															textTransform: 'none !important'
														})
													}}  
													onClick={(e: any) => {  
														handleClick(e, item.text, item.link);  
														(item.onClick as any)?.(e);  
													}}  
												>  
													{formatBreadcrumbText(item.text, isPepwise2Breadcrumb)}  
												</Typography>  
											</Box>  
										) : (  
											<Typography  
												variant="pageHeader"  
												title={item.text}  
												sx={{  
													color: breadcrumbColor,
													fontWeight: breadcrumbFontWeight,
													...(isPepwise2Breadcrumb && {
														fontSize: '18px !important',
														textTransform: 'none !important'
													})
												}}  
												{...((idx < title.length - 1 || item.text.length > 60) && idx !== 2 && hasEllipsis && breadCrumbStyle)}  
											>  
												{formatBreadcrumbText(item.text, isPepwise2Breadcrumb)}  
											</Typography>  
										)}  
										{renderBreadcrumbSeparator(isCurrentPage, true)}
									</Stack>  
								);
							})}  
						</Stack>  
					)  
				)}  
  
				{!!lastSync && (  
					<Stack direction="row" color="light.main" gap={0.5} ml={1}>  
						<ReloadIcon /> {isDataRefresh ? <Typography variant="bodyText" component="span"> Last Data Refresh: {lastSync} </Typography> : <Typography variant="bodyText" component="span"> Last Sync: {lastSync}</Typography>}  
					</Stack>  
				)}  
				{!!lastSyncPBI && (  
					<Stack direction="row" color="light.main" style={{ color: 'rgba(113, 117, 143, 1)'}} gap={0} ml={0}>  
						<ReloadIcon /> {isDataRefresh ? <Typography variant="bodyText" component="span"> Last Refreshed: {lastSyncPBI} </Typography> : <Typography variant="bodyText" component="span"> Last Sync: {lastSyncPBI}</Typography>}  
					</Stack>  
				)}  
				{!!alertContent && (  
					<Stack direction="row" color="light.main" style={{ color: 'rgba(113, 117, 143, 1)'}} gap={0} ml={2}>  
						<Typography variant="bodyText" component="span">{alertContent}</Typography>  
					</Stack>  
				)}  
			</Stack>  
			<Stack  
					direction={{ xs: 'column', sm: 'row' }}  
					gap={2}  
					alignItems={{ xs: 'flex-end', md: 'center'}}  
					justifyContent={{ xs: 'flex-end'}}  
					width={{ xs: '100%', md: 'auto' }}  
					pr={{ xs: 1, md: 'initial' }}  
					my={{ xs: 2, md: 1.5 }}  
					{...childrenContainerProps}  
			>  
				{children}  
			</Stack>  
		</Stack>  
	);  
};  
  
export default PageHeader;
